module.exports = __webpack_public_path__ + "img/vcf.6509c53d.svg";